import React from 'react';

// Read-only. Status changes, cancel and refund stay on the booking page (docs/director-reporting-prototype.md, Decisions).
export const statusStyles = {
  Active: { badge: 'tw-bg-green-50 tw-text-green-700', dot: 'tw-bg-green-600' },
  Pending: { badge: 'tw-bg-blue-50 tw-text-blue-700', dot: 'tw-bg-blue-600' },
  Cancelled: { badge: 'tw-bg-neutral-100 tw-text-neutral-500', dot: 'tw-bg-neutral-400' },
  Refunded: { badge: 'tw-bg-amber-50 tw-text-amber-700', dot: 'tw-bg-amber-500' },
  'Cancelled & refunded': { badge: 'tw-bg-neutral-100 tw-text-neutral-600', dot: 'tw-bg-amber-500' },
};

export function StatusBadge({ status, title }) {
  const s = statusStyles[status] || statusStyles.Cancelled;
  return (
    <span title={title} className={`tw-inline-flex tw-items-center tw-gap-1.5 tw-whitespace-nowrap tw-rounded-full tw-px-2.5 tw-py-0.5 tw-text-xs tw-font-medium ${s.badge}`}>
      <span className={`tw-h-1.5 tw-w-1.5 tw-rounded-full ${s.dot}`} aria-hidden />
      {status}
    </span>
  );
}
